
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { ServiceFormDialog } from "@/components/service-form/ServiceFormDialog";
import { Service } from "@/types/dashboard";
import { useState, useEffect } from "react";

interface CreateServiceProps {
  onSuccess?: () => void;
  initialData?: Service;
  refreshServices?: () => Promise<void>;
}

const CreateService = ({ onSuccess, initialData, refreshServices }: CreateServiceProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  
  // When dialog is closed, navigate back or call onSuccess
  const handleOpenChange = (open: boolean) => {
    setOpen(open);
    if (!open) {
      if (onSuccess) {
        onSuccess();
      } else {
        navigate(-1);
      }
    }
  };

  // Ensure that when we navigate away, we make a fresh start when returning
  useEffect(() => {
    return () => {
      // This will run when the component unmounts
      console.log("CreateService component unmounting");
    };
  }, []);

  // Handle successful submission including triggering a refresh
  const handleServiceSuccess = async () => {
    try {
      console.log("Service saved successfully in CreateService");
      // First refresh services to ensure we have the latest data
      if (refreshServices) {
        await refreshServices();
        console.log("Services refreshed from CreateService");
      }
      
      // Navigate to dashboard with refresh parameter - make this a replace to avoid navigation history issues
      navigate('/dashboard/services?refresh=true', { replace: true });
      
      // Then call the original onSuccess if provided
      if (onSuccess) {
        await onSuccess();
      }
    } catch (error) {
      console.error("Error in handleServiceSuccess:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <Header />
      <div className="pt-24 pb-12">
        <ServiceFormDialog
          open={open}
          onOpenChange={handleOpenChange}
          onSuccess={handleServiceSuccess}
          initialData={initialData}
          refreshServices={refreshServices}
          // Add this key to ensure the component gets fully remounted when needed
          key={`create-service-dialog-${initialData?.id || 'new'}`}
        />
      </div>
    </div>
  );
};

export default CreateService;
